// extracted by mini-css-extract-plugin
export default {"charts":"BaseStatisticsChart_charts__6K0U9","charts__block":"BaseStatisticsChart_charts__block__EH38n"};